(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3UserSettings', {
            templateUrl: 'app/shared/user-settings/user-settings.component.html',
            controller: AccountSettingsComponent,
            bindings: {
                settings: '<data',
                isAdminMode: '<'
            }
        });

    var copy = angular.copy,
        noop = angular.noop;

    AccountSettingsComponent.$inject = ['$scope', '$filter', '$timeout', '$state', 'Member', 'shared_resources', 'requestCardModal', 'signInManager', 'gender', 'cultureName', 'user', 'clubMembershipLevelType', 'upgradeToGoldModal', 'alert', 'scorePostingMethod', 'changePasswordModal', 'membershipCardInformationModal', 'cancelSubscriptionModal'];
    function AccountSettingsComponent($scope, $filter, $timeout, $state, Member, resources, requestCardModal, signInManager, gender, cultureName, user, clubMembershipLevelType, upgradeToGoldModal, alert, scorePostingMethod, changePasswordModal, membershipCardInformationModal, cancelSubscriptionModal) {
        // Variables
        var ctrl = this,
            rNonAlphanumeric = /[^a-zA-Z\d]/,
            rDigit = /\d/,
            rLowerCase = /[a-z]/,
            rUpperCase = /[A-Z]/,
            addressFields = ['firstName', 'lastName', 'address1', 'address2', 'city', 'region', 'postalCode'];

        // Properties
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });
        ctrl.datePickerOptions = { minDate: getMinDate(), maxDate: getMaxDate() };
        ctrl.commitedAddress = null; // <== address from database.  If any address field (except address2) is missing, will be set to null.
        ctrl.genderList = [gender.Male, gender.Female];
        ctrl.cultureList = [cultureName.en_CA, cultureName.fr_CA];
        Object.defineProperty(ctrl, 'canRenew', { get: canRenew });

        ctrl.scorePostingMethods = Object
            .values(scorePostingMethod.$metadata)
            .filter(function (x) { return x.value != scorePostingMethod.Statistics; });

        // Methods
        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.showRequestCardModal = showRequestCardModal;
        ctrl.showCancelSubscriptionModal = showCancelSubscriptionModal;
        ctrl.showMembershipCardInformationModal = showMembershipCardInformationModal;
        ctrl.showChangePasswordModal = showChangePasswordModal;
        ctrl.validateDateOfBirthRequired = validateDateOfBirthRequired;

        ////////////////////////////////////////////
        function init() {
            setCommitedAddress(ctrl.settings);
            if (ctrl.settings.isNewMember) {
                showChangePasswordModal();
            }
        }

        function submit() {
            var settings = ctrl.settings;
            if (ctrl.form.$valid) {
                if (!settings.password && !settings.verification)
                    settings.password = settings.verification = null;

                Member.saveSettings({ id: settings.individualId }, settings, true).$promise
                    .then(setPristine)                        
                    .then(refreshUser)
                    .then(showSuccess)
                    .catch(showError);
            }

            function setPristine(settings) {
                setCommitedAddress(ctrl.settings = settings);
                ctrl.form.$setPristine();
            }

            function refreshUser(settings) {
                return signInManager.refresh().catch(noop);
            }

            function showSuccess() {
                $scope.$emit('$userChanged');
                $timeout(alert.success.bind(alert, resources.saveSettingsSucceeded));
            }

            function showError() {
                alert.error(resources.saveSettingsFailed);
            }
        }

        function showRequestCardModal() {
            var commitedAddress = ctrl.commitedAddress,
                isBronze = user.membershipLevel === clubMembershipLevelType.Bronze;

            if (!isBronze && commitedAddress)
                requestCardModal(commitedAddress).result.then(requestCard).catch(noop);
            else if (isBronze) 
                upgradeToGoldModal();

            function requestCard() {
                var individualId = ctrl.settings.individualId;
                Member.requestCard({ id: individualId }, success, error, true);

                function success(response) {
                    alert.success(resources.requestCardSucceeded);
                }
                function error() {
                    alert.error(resources.requestCardFailed);
                }
            }
        }

        function showCancelSubscriptionModal() {

            var now = new Date();
            var renewDate = ctrl.settings.subscriptionRenewsOn;

            if (renewDate > now)
                cancelSubscriptionModal().result.then(cancelSubscription).catch(noop);

            function cancelSubscription() {
                var stripeSubscriptionId = ctrl.settings.stripeSubscriptionId;
                var settings = ctrl.settings;
                Member.cancelSubscription({ id: settings.individualId}, success, error, true);

                function success(response) {
                    ctrl.settings.subscriptionRenewsOn = null;
                    alert.success(resources.cancelSubscriptionSucceeded);
                }
                function error() {
                    alert.error(resources.cancelSubscriptionFailed);
                }
            }
        }
               
        function showChangePasswordModal() {
            var settings = ctrl.settings;
            var modal = changePasswordModal({ individualId: settings.individualId, isNewMember: settings.isNewMember });
            modal.closed.then(function () {
                ctrl.settings.isNewMember = false;
            });
        }

        function showMembershipCardInformationModal() {
            var settings = ctrl.settings;
            var modal = membershipCardInformationModal({ individualId: settings.individualId, isCardsSentToClub: settings.isCardsSentToClub });
        }


        function setCommitedAddress(settings) {
            var hasValidAddress = settings.firstName && settings.lastName && settings.address1 && settings.city && settings.region && settings.postalCode;
            ctrl.commitedAddress = hasValidAddress ? copyAddress(settings): null;

            function copyAddress(settings) {
                return addressFields.reduce(reduce, {});
                function reduce(acc, curr) {
                    return (acc[curr] = settings[curr]) && acc || acc;
                }
            }
        }

        function validateDateOfBirthRequired(value) {
            return !!value || ctrl.isAdminPage;
        }

        function getMinDate() {
            var now = new Date();
            now.setYear(now.getFullYear() - 110);
            return now;
        }

        function getMaxDate() {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); // end of day
        }

        function canRenew() {
            return ctrl.settings.level !== clubMembershipLevelType.Default;
        }

        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }
    }
})();